import * as React from 'react';
import styled from 'styled-components';
import { AnalyticsLocationProvider } from 'latitude-analytics';
import { Flex } from '@latitude/box';
import { Text } from '@latitude/text';
import { Heading3 } from '@latitude/heading';
import { ALIGN, ALIGN_ITEMS, BREAKPOINT, COLOR, FONT_WEIGHT, FLEX_DIRECTION, JUSTIFY_CONTENT, MARGIN } from '@latitude/core/utils/constants';
import Callout from './Callout';
var Title = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "CalloutTwoColumn__Title",
  componentId: "sc-11vvjmp-0"
})(["align-items:", ";justify-content:", ";min-width:40%;h3{color:", ";margin-bottom:", ";@media (min-width:", "){margin-bottom:0;}}"], ALIGN_ITEMS.CENTER, JUSTIFY_CONTENT.CENTER, COLOR.WHITE, MARGIN.M24, BREAKPOINT.LG);
var ContactDetails = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "CalloutTwoColumn__ContactDetails",
  componentId: "sc-11vvjmp-1"
})(["flex-direction:", ";align-items:", ";> p{width:100%;color:", ";text-align:", ";}@media (min-width:", "){align-items:", ";}"], FLEX_DIRECTION.COLUMN, ALIGN_ITEMS.CENTER, COLOR.WHITE, ALIGN.CENTER, BREAKPOINT.LG, ALIGN_ITEMS.FLEX_START);

var CalloutTwoColumn = function CalloutTwoColumn(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "We're here to help" : _ref$heading,
      line1 = _ref.line1,
      line2 = _ref.line2;
  return /*#__PURE__*/React.createElement(AnalyticsLocationProvider, {
    location: heading
  }, /*#__PURE__*/React.createElement(Callout, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(Heading3, null, heading)), /*#__PURE__*/React.createElement(ContactDetails, null, line1 && /*#__PURE__*/React.createElement(Text, null, line1), line2 && /*#__PURE__*/React.createElement(Text, {
    fontWeight: FONT_WEIGHT.BOLD
  }, line2))));
};

export default CalloutTwoColumn;